<template>
  <div id="app">
    <Menu v-if="this.$router.currentRoute.path !== '/'" />
    <router-view></router-view>
  </div>
</template>

<script>
import Menu from "./components/Menu";

export default {
  name: "app",
  components: {
    Menu
  }
};
</script>

<style>
body {
  background: #f2f2f2 !important;
}

.lightShadow {
  box-shadow: 0px 0.3em 0.5em rgba(0, 0, 0, 0.05) !important;
}

p,
a,
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Open Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6,
button {
  font-family: "Open Sans", sans-serif !important;
  font-weight: 700 !important;
  /* font-size: 18px !important; */
}

h5 {
  font-size: 18px !important;
}

small {
  color: #b1b1b1;
}

.nav-link {
  font-weight: 700;
}
</style>
